// removed by extract-text-webpack-plugin
module.exports = {"giftIcon":"_2iaInyreljepyiFr6620AE","promoGiftIcon":"_3VJhLavZ6rOSUOVZtFUATv","promoHeading":"_3Kt_0VtAq0KAnWnGBfTBNy","promoSubHeading":"_1-ConNUH8dYa_inqQ7x2xX","viewOffersButton":"_1ndwm7dBaevVklctRqTRHC","viewOffersButtonText":"_1uM2uzr-IB1m5JaqTzaet5","doNotShowText":"Td-6Mt3UatFO0mSVlkJMP","label":"_24e8lba44DuEFbGEJH7Glx","checkboxs":"_3rFxwicFPS-810mZsXdlql"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/giftForYou.css
// module id = 910
// module chunks = 0